module.exports = __webpack_public_path__ + "img/czw.27237e62.png";